"use strict";
// tslint:disable
// eslint-disable
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScenarioApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class ScenarioApi extends runtime.BaseAPI {
    /**
     * Creates scenario, sets its raw input value (free-form JSON) and starts execution. Bypasses input value validation, except for well-formedness check.
     * Create and execute scenario
     */
    createAndExecuteScenarioRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioExecuteRequestDTO === null || requestParameters.scenarioExecuteRequestDTO === undefined)) {
                throw new runtime.RequiredError('scenarioExecuteRequestDTO', 'Required parameter requestParameters.scenarioExecuteRequestDTO was null or undefined when calling createAndExecuteScenario.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/createAndExecute`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ScenarioExecuteRequestDTOToJSON(requestParameters.scenarioExecuteRequestDTO),
            });
            return new runtime.TextApiResponse(response);
        });
    }
    /**
     * Creates scenario, sets its raw input value (free-form JSON) and starts execution. Bypasses input value validation, except for well-formedness check.
     * Create and execute scenario
     */
    createAndExecuteScenario(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createAndExecuteScenarioRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Creates scenario record, setting its basic parameters (eg. name)
     * Create scenario
     */
    createScenarioRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.executionSetupId === null || requestParameters.executionSetupId === undefined)) {
                throw new runtime.RequiredError('executionSetupId', 'Required parameter requestParameters.executionSetupId was null or undefined when calling createScenario.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioCreateDTO === null || requestParameters.scenarioCreateDTO === undefined)) {
                throw new runtime.RequiredError('scenarioCreateDTO', 'Required parameter requestParameters.scenarioCreateDTO was null or undefined when calling createScenario.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{executionSetupId}`.replace(`{${"executionSetupId"}}`, encodeURIComponent(String(requestParameters.executionSetupId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ScenarioCreateDTOToJSON(requestParameters.scenarioCreateDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Creates scenario record, setting its basic parameters (eg. name)
     * Create scenario
     */
    createScenario(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createScenarioRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Creates scenario group.
     * Create scenario group
     */
    createScenarioGroupRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.executionSetupId === null || requestParameters.executionSetupId === undefined)) {
                throw new runtime.RequiredError('executionSetupId', 'Required parameter requestParameters.executionSetupId was null or undefined when calling createScenarioGroup.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioGroupUpdateDTO === null || requestParameters.scenarioGroupUpdateDTO === undefined)) {
                throw new runtime.RequiredError('scenarioGroupUpdateDTO', 'Required parameter requestParameters.scenarioGroupUpdateDTO was null or undefined when calling createScenarioGroup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenarioGroup/{executionSetupId}`.replace(`{${"executionSetupId"}}`, encodeURIComponent(String(requestParameters.executionSetupId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ScenarioGroupUpdateDTOToJSON(requestParameters.scenarioGroupUpdateDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioGroupDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Creates scenario group.
     * Create scenario group
     */
    createScenarioGroup(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createScenarioGroupRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes scenario along with its input values and results. Operation is irreversible. Scenario must be in draft status.
     * Delete scenario
     */
    deleteScenarioRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling deleteScenario.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{scenarioId}`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes scenario along with its input values and results. Operation is irreversible. Scenario must be in draft status.
     * Delete scenario
     */
    deleteScenario(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteScenarioRaw(requestParameters);
        });
    }
    /**
     * Deletes scenario group.
     * Delete scenario group
     */
    deleteScenarioGroupRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioGroupId === null || requestParameters.scenarioGroupId === undefined)) {
                throw new runtime.RequiredError('scenarioGroupId', 'Required parameter requestParameters.scenarioGroupId was null or undefined when calling deleteScenarioGroup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenarioGroup/{scenarioGroupId}`.replace(`{${"scenarioGroupId"}}`, encodeURIComponent(String(requestParameters.scenarioGroupId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes scenario group.
     * Delete scenario group
     */
    deleteScenarioGroup(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteScenarioGroupRaw(requestParameters);
        });
    }
    /**
     * Get scenario groups based on provided criteria. Supports paginated output.
     * Find scenario groups
     */
    findScenarioGroupsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.orderBy === null || requestParameters.orderBy === undefined)) {
                throw new runtime.RequiredError('orderBy', 'Required parameter requestParameters.orderBy was null or undefined when calling findScenarioGroups.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling findScenarioGroups.');
            }
            const queryParameters = {};
            if (requestParameters.orderDesc !== undefined) {
                queryParameters['orderDesc'] = requestParameters.orderDesc;
            }
            if (requestParameters.pageIndex !== undefined) {
                queryParameters['pageIndex'] = requestParameters.pageIndex;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.orderBy !== undefined) {
                queryParameters['orderBy'] = requestParameters.orderBy;
            }
            if (requestParameters.executionSetupId !== undefined) {
                queryParameters['executionSetupId'] = requestParameters.executionSetupId;
            }
            if (requestParameters.name !== undefined) {
                queryParameters['name'] = requestParameters.name;
            }
            if (requestParameters.modelUuid !== undefined) {
                queryParameters['modelUuid'] = requestParameters.modelUuid;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenarioGroup`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioGroupListDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get scenario groups based on provided criteria. Supports paginated output.
     * Find scenario groups
     */
    findScenarioGroups(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.findScenarioGroupsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get accessible scenarios based on provided criteria. Supports paginated output.
     * Find scenarios
     */
    findScenariosRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.orderBy === null || requestParameters.orderBy === undefined)) {
                throw new runtime.RequiredError('orderBy', 'Required parameter requestParameters.orderBy was null or undefined when calling findScenarios.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling findScenarios.');
            }
            const queryParameters = {};
            if (requestParameters.orderDesc !== undefined) {
                queryParameters['orderDesc'] = requestParameters.orderDesc;
            }
            if (requestParameters.pageIndex !== undefined) {
                queryParameters['pageIndex'] = requestParameters.pageIndex;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.orderBy !== undefined) {
                queryParameters['orderBy'] = requestParameters.orderBy;
            }
            if (requestParameters.query !== undefined) {
                queryParameters['query'] = requestParameters.query;
            }
            if (requestParameters.modelUuid !== undefined) {
                queryParameters['modelUuid'] = requestParameters.modelUuid;
            }
            if (requestParameters.status) {
                queryParameters['status'] = requestParameters.status;
            }
            if (requestParameters.name) {
                queryParameters['name'] = requestParameters.name;
            }
            if (requestParameters.createdBy) {
                queryParameters['createdBy'] = requestParameters.createdBy;
            }
            if (requestParameters.createdOnMonth) {
                queryParameters['createdOnMonth'] = requestParameters.createdOnMonth;
            }
            if (requestParameters.outdated !== undefined) {
                queryParameters['outdated'] = requestParameters.outdated;
            }
            if (requestParameters.executionType !== undefined) {
                queryParameters['executionType'] = requestParameters.executionType;
            }
            if (requestParameters.executionSetupId !== undefined) {
                queryParameters['executionSetupId'] = requestParameters.executionSetupId;
            }
            if (requestParameters.modelInputId !== undefined) {
                queryParameters['modelInputId'] = requestParameters.modelInputId;
            }
            if (requestParameters.userId !== undefined) {
                queryParameters['userId'] = requestParameters.userId;
            }
            if (requestParameters.hidden !== undefined) {
                queryParameters['hidden'] = requestParameters.hidden;
            }
            if (requestParameters.all !== undefined) {
                queryParameters['all'] = requestParameters.all;
            }
            if (requestParameters.view !== undefined) {
                queryParameters['view'] = requestParameters.view;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioListDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get accessible scenarios based on provided criteria. Supports paginated output.
     * Find scenarios
     */
    findScenarios(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.findScenariosRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get scenario detail
     */
    getScenarioDetailRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling getScenarioDetail.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{scenarioId}`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get scenario detail
     */
    getScenarioDetail(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getScenarioDetailRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Return list of model execution errors
     * Get scenario error
     */
    getScenarioErrorRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling getScenarioError.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{scenarioId}/error`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.OutputDTOFromJSON));
        });
    }
    /**
     * Return list of model execution errors
     * Get scenario error
     */
    getScenarioError(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getScenarioErrorRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get scenario group detail
     */
    getScenarioGroupDetailRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioGroupId === null || requestParameters.scenarioGroupId === undefined)) {
                throw new runtime.RequiredError('scenarioGroupId', 'Required parameter requestParameters.scenarioGroupId was null or undefined when calling getScenarioGroupDetail.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenarioGroup/{scenarioGroupId}`.replace(`{${"scenarioGroupId"}}`, encodeURIComponent(String(requestParameters.scenarioGroupId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioGroupDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get scenario group detail
     */
    getScenarioGroupDetail(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getScenarioGroupDetailRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Return status archived output either as file or as zip if multiple files are present. Filename specified in Content-Disposition response header
     * Get scenario output
     */
    getScenarioOutputRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling getScenarioOutput.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{scenarioId}/output`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * Return status archived output either as file or as zip if multiple files are present. Filename specified in Content-Disposition response header
     * Get scenario output
     */
    getScenarioOutput(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getScenarioOutputRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Provides Excel file containing scenario output
     */
    getScenarioOutputExportRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling getScenarioOutputExport.');
            }
            const queryParameters = {};
            if (requestParameters.indexPart) {
                queryParameters['indexPart'] = requestParameters.indexPart;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{scenarioId}/output-export`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * Provides Excel file containing scenario output
     */
    getScenarioOutputExport(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getScenarioOutputExportRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Returns scenario status and scenario error output
     * Get scenario status and error output
     */
    getScenarioStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling getScenarioStatus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{scenarioId}/status`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioStatusResponseDTOFromJSON(jsonValue));
        });
    }
    /**
     * Returns scenario status and scenario error output
     * Get scenario status and error output
     */
    getScenarioStatus(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getScenarioStatusRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Set scenarios outdate attributes to true by execution setup id
     * Set scenarios to be outdated
     */
    outdateScenarioRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioOutdateDTO === null || requestParameters.scenarioOutdateDTO === undefined)) {
                throw new runtime.RequiredError('scenarioOutdateDTO', 'Required parameter requestParameters.scenarioOutdateDTO was null or undefined when calling outdateScenario.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/outdate`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ScenarioOutdateDTOToJSON(requestParameters.scenarioOutdateDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set scenarios outdate attributes to true by execution setup id
     * Set scenarios to be outdated
     */
    outdateScenario(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.outdateScenarioRaw(requestParameters);
        });
    }
    /**
     * Checks if a scenario already exists for the given user with the given name and model id, comparison is case-insensitive Is scenarioId is not passed, then existence is checked among invoker\'s scenarios If a scenarioId is passed, then such scenario is excluded from the check and existence is checked among scenario creator\'s scenarios
     * Check if scenario name is used
     */
    scenarioExistsByNameRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.name === null || requestParameters.name === undefined)) {
                throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling scenarioExistsByName.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling scenarioExistsByName.');
            }
            const queryParameters = {};
            if (requestParameters.name !== undefined) {
                queryParameters['name'] = requestParameters.name;
            }
            if (requestParameters.modelUuid !== undefined) {
                queryParameters['modelUuid'] = requestParameters.modelUuid;
            }
            if (requestParameters.scenarioId !== undefined) {
                queryParameters['scenarioId'] = requestParameters.scenarioId;
            }
            if (requestParameters.executionSetupId !== undefined) {
                queryParameters['executionSetupId'] = requestParameters.executionSetupId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/scenario/name/exists`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.TextApiResponse(response);
        });
    }
    /**
     * Checks if a scenario already exists for the given user with the given name and model id, comparison is case-insensitive Is scenarioId is not passed, then existence is checked among invoker\'s scenarios If a scenarioId is passed, then such scenario is excluded from the check and existence is checked among scenario creator\'s scenarios
     * Check if scenario name is used
     */
    scenarioExistsByName(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.scenarioExistsByNameRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Update input values for a specific scenario.
     * Update scenario input value
     */
    scenarioScenarioIdInputPutRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling scenarioScenarioIdInputPut.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioModelInputDTO === null || requestParameters.scenarioModelInputDTO === undefined)) {
                throw new runtime.RequiredError('scenarioModelInputDTO', 'Required parameter requestParameters.scenarioModelInputDTO was null or undefined when calling scenarioScenarioIdInputPut.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{scenarioId}/input`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ScenarioModelInputDTOToJSON(requestParameters.scenarioModelInputDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Update input values for a specific scenario.
     * Update scenario input value
     */
    scenarioScenarioIdInputPut(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.scenarioScenarioIdInputPutRaw(requestParameters);
        });
    }
    /**
     * Update label of a scenario
     * Update label of ascenario
     */
    setLabelRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling setLabel.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioLabelDTO === null || requestParameters.scenarioLabelDTO === undefined)) {
                throw new runtime.RequiredError('scenarioLabelDTO', 'Required parameter requestParameters.scenarioLabelDTO was null or undefined when calling setLabel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{scenarioId}/label`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ScenarioLabelDTOToJSON(requestParameters.scenarioLabelDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Update label of a scenario
     * Update label of ascenario
     */
    setLabel(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setLabelRaw(requestParameters);
        });
    }
    /**
     * set scenario status
     */
    setScenarioStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling setScenarioStatus.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.status === null || requestParameters.status === undefined)) {
                throw new runtime.RequiredError('status', 'Required parameter requestParameters.status was null or undefined when calling setScenarioStatus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{scenarioId}/{status}`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))).replace(`{${"status"}}`, encodeURIComponent(String(requestParameters.status))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * set scenario status
     */
    setScenarioStatus(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setScenarioStatusRaw(requestParameters);
        });
    }
    /**
     * Display scenario is accessible for the super. Notification is send to the user
     * Send notification about sharing display scenario
     */
    shareRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling share.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.shareInstanceDTO === null || requestParameters.shareInstanceDTO === undefined)) {
                throw new runtime.RequiredError('shareInstanceDTO', 'Required parameter requestParameters.shareInstanceDTO was null or undefined when calling share.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{scenarioId}/share`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ShareInstanceDTOToJSON(requestParameters.shareInstanceDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Display scenario is accessible for the super. Notification is send to the user
     * Send notification about sharing display scenario
     */
    share(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.shareRaw(requestParameters);
        });
    }
    /**
     * Updates scenario basic parameters (eg. name).
     * Update scenario
     */
    updateScenarioRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling updateScenario.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioUpdateDTO === null || requestParameters.scenarioUpdateDTO === undefined)) {
                throw new runtime.RequiredError('scenarioUpdateDTO', 'Required parameter requestParameters.scenarioUpdateDTO was null or undefined when calling updateScenario.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenario/{scenarioId}`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ScenarioUpdateDTOToJSON(requestParameters.scenarioUpdateDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Updates scenario basic parameters (eg. name).
     * Update scenario
     */
    updateScenario(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateScenarioRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Updates scenario group basic parameters (eg. name).
     * Update scenario group
     */
    updateScenarioGroupRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioGroupId === null || requestParameters.scenarioGroupId === undefined)) {
                throw new runtime.RequiredError('scenarioGroupId', 'Required parameter requestParameters.scenarioGroupId was null or undefined when calling updateScenarioGroup.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioGroupUpdateDTO === null || requestParameters.scenarioGroupUpdateDTO === undefined)) {
                throw new runtime.RequiredError('scenarioGroupUpdateDTO', 'Required parameter requestParameters.scenarioGroupUpdateDTO was null or undefined when calling updateScenarioGroup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenarioGroup/{scenarioGroupId}`.replace(`{${"scenarioGroupId"}}`, encodeURIComponent(String(requestParameters.scenarioGroupId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ScenarioGroupUpdateDTOToJSON(requestParameters.scenarioGroupUpdateDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioGroupDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Updates scenario group basic parameters (eg. name).
     * Update scenario group
     */
    updateScenarioGroup(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateScenarioGroupRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.ScenarioApi = ScenarioApi;
